import { useGetProposal } from '@/api/queries/proposal/useGetProposal';
import ProposalStatusBadge from '@/ui/pages/proposalBuilderPage/components/ProposalStatusBadge';
import { getSentProposalStatus } from '@/ui/pages/proposalBuilderPage/components/sentProposalPanel/sentProposalStatus';
import { H4 } from '@payaca/ambrosia';
import { FC } from 'react';

type ProposalHeaderIdentityProps = {
  proposalId: string;
};

const ProposalHeaderIdentity: FC<ProposalHeaderIdentityProps> = (props) => {
  const { proposalId } = props;

  const { proposal } = useGetProposal(proposalId);

  return (
    <div className="flex items-center gap-2 min-w-0">
      <H4 truncate>#{proposal?.customReference ?? proposal?.reference}</H4>

      <ProposalStatusBadge
        status={getSentProposalStatus(proposal) ?? 'draft'}
      />
    </div>
  );
};

export default ProposalHeaderIdentity;
